import StyledLink$1 from '../../Basic/Link/Link.mjs';
import styled from 'styled-components';

const StyledList = styled.ul `
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  padding: 6px 0;
  list-style: none;
  margin: 0;
  background: ${props => props.theme.colors.mutedBackgroundColor};

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    gap: 1.5rem;
    flex-wrap: wrap;
    padding: 24px 16px;
  }
`;
const StyledListItem = styled.li ``;
const StyledLink = styled(StyledLink$1) `
  color: ${props => props.theme.colors.mutedTextColor};
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  line-height: ${props => props.theme.typography.text.tiny.lineHeight};
  padding: 0 12px;

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0;
  }
`;

export { StyledLink, StyledList, StyledListItem };
//# sourceMappingURL=BottomLinks.styles.mjs.map
